module.exports = __webpack_public_path__ + "img/optimum.505743ff.png";